import React from 'react';
import { StarIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { stats } from '../../data/stats';
import { container } from '../../utils/styles';
export function StatsBand() {
  const {
    t
  } = useLanguage();
  const [primary, ...rest] = stats;
  return <section className="bg-white py-14 sm:py-16" aria-label={t({
    en: 'A.M. Home Care by the numbers',
    es: 'A.M. Home Care en cifras'
  })} data-id="element-54" data-mp="1ar6xtvb0mlr0">
      <div className={container} data-id="element-55" data-mp="15t5dz85rmieh">
        <dl className="grid gap-y-8 rounded-2xl bg-brand-tint p-8 sm:grid-cols-2 sm:p-10 lg:grid-cols-12 lg:items-center lg:gap-0" data-id="element-56" data-mp="110ueg6exsymg">
          <div className="sm:col-span-2 lg:col-span-4 lg:border-r lg:border-brand/15 lg:pr-10" data-id="element-57" data-mp="w0zqobqgkp5m">
            <dd className="font-display text-6xl font-bold leading-none text-brand-dark sm:text-7xl" data-id="element-58" data-mp="r3g0cdghklxb">{primary.value}</dd>
            <dt className="mt-3 text-xl font-semibold text-ink" data-id="element-59" data-mp="mzrsrurutqc2">{t(primary.label)}</dt>
            <p className="mt-1 text-ink-soft" data-id="element-60" data-mp="i31d38jyowr6">
              {t({
              en: 'across Northern Virginia',
              es: 'en todo el norte de Virginia'
            })}
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:col-span-2 lg:col-span-8 lg:grid-cols-4 lg:pl-10" data-id="element-61" data-mp="2buxxpbq9mavt">
            {rest.map(s => <div key={s.id} className="flex flex-col-reverse" data-id="element-62" data-mp="1y547oq30xkki">
                <dt className="mt-2 font-medium text-ink-soft" data-id="element-63" data-mp="2254uoz46v436">{t(s.label)}</dt>
                <dd className="flex items-baseline gap-2 font-display text-4xl font-bold text-ink" data-id="element-64" data-mp="22321653tustp">
                  {s.value}
                  {s.id === 'rating' && <span className="flex gap-0.5 self-center" aria-hidden="true" data-id="element-65" data-mp="2utaixvugbb7r">
                      {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-66" data-mp="2lsvu4mia3dzi" data-mpi={i} />)}
                    </span>}
                </dd>
              </div>)}
          </div>
        </dl>
      </div>
    </section>;
}